module.exports = __webpack_public_path__ + "img/project-33.a5938d2b.png";